<!-- =========================================================================================
  File Name: EditCourse.vue
  Description: User Edit Page

========================================================================================== -->

<template>
  <div id="page-user-edit">
    <vs-alert color="danger" title="Lab Not Found" :active.sync="errorOccurred">
      <span>Lab account record with id: {{ $route.params.labId }} not found. </span>
      <span>
        <span>Check </span
        ><router-link :to="{ name: 'admin-list-lab-accounts' }" class="text-inherit underline">All Labs Accounts</router-link>
      </span>
    </vs-alert>

    <vx-card class="mb-4" v-if="lab_data">
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="Details" icon-pack="feather" icon="icon-edit">
            <labs-details-tab
              class="mt-4"
              :data="lab_data"
              v-on:update_lab_data="update_lab_data"
              v-on:refresh_lab_data="refresh_lab_data"
              :key="refresh_key"
            />
          </vs-tab>
          <vs-tab label="Debug" icon-pack="feather" icon="icon-code">
            <labs-debug-tab class="mt-4" :data="lab_data" :key="refresh_key" />
          </vs-tab>
        </vs-tabs>
      </div>
    </vx-card>
  </div>
</template>

<script>
import LabsDebugTab from './AccountDebugTab.vue'
import LabsDetailsTab from './AccountDetailsTab.vue'
import axios from 'axios'

export default {
  components: {
    LabsDetailsTab,
    LabsDebugTab
  },
  data () {
    return {
      lab_data: null,
      errorOccurred: false,

      refresh_key: 0,

      activeTab: 0
    }
  },
  watch: {
    activeTab () {
      this.load_lab_data(this.$route.params.labId)
    }
  },
  methods: {
    load_lab_data () {
      axios
        .get(`${process.env.VUE_APP_ROOT_LABS_API}/labs/accounts/${this.$route.params.labId}`)
        .then((response) => {
          if (response.status === 200) {
            this.lab_data = response.data
            this.refresh_key++
          }
        })
        .catch((error) => {
          this.errorOccurred = true
          this.error_msg = error
        })
    },
    update_lab_data (data) {
      const pl = {
        username: data.username,
        password: data.password,
        assignmentId: data.assignmentId,
        accountId: data.accountId,
        userAgent: data.userAgent,
        pool: data.pool
      }

      this.$vs.loading()

      axios
        .patch(`${process.env.VUE_APP_ROOT_LABS_API}/labs/accounts/${this.$route.params.labId}`, pl)
        .then((response) => {
          if (response.status === 200) {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Updated Lab Account Successfully',
              text: `${pl.username} has been updated.`,
              color: 'success',
              position: 'top-right'
            })
            this.load_lab_data(this.$route.params.labId)
          }
        })
        .catch((exception) => {
          this.$vs.loading.close()

          let error = 'An unknown error occurred while updating this account'
          if (exception.response) {
            error = exception.response.data.error.description
          }

          return this.$vs.notify({
            title: 'Failed to update account',
            text: error,
            color: 'danger',
            position: 'top-right'
          })
        })
    },
    refresh_lab_data (data) {
      this.$vs.loading()

      axios
        .patch(`${process.env.VUE_APP_ROOT_LABS_API}/labs/accounts/${this.$route.params.labId}/reset`, {})
        .then((response) => {
          if (response.status === 200) {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Reset Lab Account Successfully',
              text: `${data.username} has been reset.`,
              color: 'success',
              position: 'top-right'
            })
            this.load_lab_data(this.$route.params.labId)
          }
        })
        .catch((exception) => {
          this.$vs.loading.close()

          let error = 'An unknown error occurred while resetting this account'
          if (exception.response) {
            error = exception.response.data.error.description
          }

          return this.$vs.notify({
            title: 'Failed to reset account',
            text: error,
            color: 'danger',
            position: 'top-right'
          })
        })
    }
  },
  created () {
    this.load_lab_data(this.$route.params.labId)
  }
}
</script>
